// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_copyright-module__container--4Z6SE","link":"footer_copyright-module__link--2Yw4S"};